import login from './../views/auth/login.vue'

import Home from './../views/Home.vue'
import About from './../views/About.vue'

import ketapang_master_jenis_bahan_pangan from './../views/ketapang/master/jenis_bahan_pangan.vue'
import ketapang_master_komoditi from './../views/ketapang/master/komoditi.vue'

import ketapang_master_provinsi from './../views/ketapang/master/kode_provinsi.vue'
import ketapang_master_lumbung_pangan from './../views/ketapang/master/lumbung_pangan.vue'
import ketapang_master_kab from './../views/ketapang/master/kode_kab.vue'
import ketapang_master_kecamatan from './../views/ketapang/master/kode_kecamatan.vue'
import ketapang_master_desa from './../views/ketapang/master/kode_desa.vue'
import ketapang_master_puskesmas from './../views/ketapang/master/kode_puskesmas.vue'
import ketapang_master_bobot_data_produksi from './../views/ketapang/master/master_value/bobot_data_produksi.vue'

import data_entri_luas_tanaman_padi from './../views/ketapang/data_entri/luas_tanaman_padi.vue'

import data_produksi_beras from './../views/ketapang/produksi_beras/produksi_beras.vue'
import data_luas_tanam_padi from './../views/ketapang/luas_tanam_padi/luas_tanam_padi.vue'

import data_laP_gizi from './../views/ketapang/data_gizi/data_gizi.vue'
import data_panel_harga_pangan from './../views/ketapang/panel_harga/panel_harga_pangan.vue'

import lap_spkg_akses_pangan from './../views/ketapang/lap/spkg/akses_pangan.vue'
import lap_spkg_luas_tanaman from './../views/ketapang/lap/spkg/luas_tanaman.vue'
import lap_spkg_pemanfaatan_pangan from './../views/ketapang/lap/spkg/pemanfaatan_pangan.vue'

import anggota_kelompok from './../views/ketapang/KWT/anggota_kelompok.vue'
import master_kelompok from './../views/ketapang/KWT/master_kelompok.vue'

import iventarisP2L from './../views/ketapang/KWT/iventarisP2L.vue'


// iventarisP2L

function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/dashboard');
    } else {
      next();
    }
  }
  
  function isLoggedIn(to, from, next) {
    if (localStorage.token) {
      next();
    } else {
      next('/monev_login');
    }
  }
  
  var routes = [
    {
      path: '/login',
      name: '/login',
      component: login,
      beforeEnter: loggedInRedirectDashboard,
    },
    {
      path: '/about',
      name: '/about',
      component: About,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/ketapang_master_jenis_bahan_pangan',
      name: '/ketapang_master_jenis_bahan_pangan',
      component: ketapang_master_jenis_bahan_pangan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/',
      name: '/home',
      component: Home,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_komoditi',
      name: '/ketapang_master_komoditi',
      component: ketapang_master_komoditi,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/ketapang_master_provinsi',
      name: '/ketapang_master_provinsi',
      component: ketapang_master_provinsi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_kab',
      name: '/ketapang_master_kab',
      component: ketapang_master_kab,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_kecamatan',
      name: '/ketapang_master_kecamatan',
      component: ketapang_master_kecamatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_desa',
      name: '/ketapang_master_desa',
      component: ketapang_master_desa,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_bobot_data_produksi',
      name: '/ketapang_master_bobot_data_produksi',
      component: ketapang_master_bobot_data_produksi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_puskesmas',
      name: '/ketapang_master_puskesmas',
      component: ketapang_master_puskesmas,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/data_entri_luas_tanaman_padi',
      name: '/data_entri_luas_tanaman_padi',
      component: data_entri_luas_tanaman_padi,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/data_produksi_beras',
      name: '/data_produksi_beras',
      component: data_produksi_beras,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/data_luas_tanam_padi',
      name: '/data_luas_tanam_padi',
      component: data_luas_tanam_padi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/data_laP_gizi',
      name: '/data_laP_gizi',
      component: data_laP_gizi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/data_panel_harga_pangan',
      name: '/data_panel_harga_pangan',
      component: data_panel_harga_pangan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/ketapang_master_lumbung_pangan',
      name: '/ketapang_master_lumbung_pangan',
      component: ketapang_master_lumbung_pangan,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/lap_spkg_akses_pangan',
      name: '/lap_spkg_akses_pangan',
      component: lap_spkg_akses_pangan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/lap_spkg_luas_tanaman',
      name: '/lap_spkg_luas_tanaman',
      component: lap_spkg_luas_tanaman,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/lap_spkg_pemanfaatan_pangan',
      name: '/lap_spkg_pemanfaatan_pangan',
      component: lap_spkg_pemanfaatan_pangan,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/anggota_kelompok',
      name: '/anggota_kelompok',
      component: anggota_kelompok,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/master_kelompok',
      name: '/master_kelompok',
      component: master_kelompok,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/iventarisP2L',
      name: '/iventarisP2L',
      component: iventarisP2L,
      beforeEnter: isLoggedIn,
    },

  
  ]





  export default routes